"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OR = void 0;
exports.OR = {
    information: {
        definition: '',
        description: '',
        requiredInputs: { min: 0 },
    },
    evaluate: (inputs) => {
        const result = inputs.some((input) => Boolean(input));
        return { error: null, result };
    },
};
//# sourceMappingURL=or.js.map